import React from "react";
import useAuthLayout from "../hooks/useAuthLayout";
import ForgotPassword from "./ForgotPassword";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import PhoneSignUp from './PhoneSignUp';
import PhoneVerification from "./PhoneVerification";

const AuthLayout = (props) => {
    const {
        isSignInOpen,
        isSignUpOpen,
        isForgotPasswordOpen,
        showPhoneSignUp,
        showPhoneVerificationOpen,
        verificationPhoneNumber,
        otpCode,
        purpose,
        signUpMessage,
        phoneUp,
        phoneUpdate,
        directSubmit,
        // handleOTPSent,
        handleSignUpOpen,
        handleForgotPasswordOpen,
        handleBackButton,
        handleSignInOpen,
        handleForgotPasswordClose,
        LoginViaEmail,
        handlePhoneVerificationOpen,
        handleSignUpOpenFromPhoneVerification
    } = useAuthLayout(props);
    return (
        <>
            {showPhoneSignUp && (
                <PhoneSignUp
                    isOpen={showPhoneSignUp}
                    handleBackButton={(isLogin) => handleBackButton("phoneSignUp", isLogin)}
                    LoginViaEmail={LoginViaEmail}
                    handlePhoneVerificationOpen={handlePhoneVerificationOpen}
                    phoneUp={phoneUp}
                    phoneUpdate={phoneUpdate}
                />
            )}
            {showPhoneVerificationOpen && (
                <PhoneVerification
                    isOpen={showPhoneVerificationOpen}
                    handleBackButton={(isLogin) => handleBackButton("phoneVerification", isLogin)}
                    phoneNumber={verificationPhoneNumber}
                    userLogin={props.userLogin}
                    handleSignUpOpenFromPhoneVerification={handleSignUpOpenFromPhoneVerification}
                    otpCode={otpCode}
                    purpose={purpose}
                    phoneUpdate={phoneUpdate}
                    isSignUpOpen={isSignUpOpen}
                />
            )}
            {isSignInOpen && (
                <SignIn
                    isOpen={isSignInOpen}
                    handleSignUpOpen={handleSignUpOpen}
                    handleForgotPasswordOpen={handleForgotPasswordOpen}
                    handleBackButton={(isLogin) => handleBackButton("signIn", isLogin)}
                />
            )}
            {isSignUpOpen && (
                <SignUp
                    isOpen={isSignUpOpen}
                    handleBackButton={() => handleBackButton("signUp")}
                    handleSignInOpen={handleSignInOpen}
                    phoneNumber={verificationPhoneNumber}
                    signUpMessage={signUpMessage}
                    handlePhoneVerificationOpen={handlePhoneVerificationOpen}
                    directSubmit={directSubmit}
                />
            )}
            {isForgotPasswordOpen && (
                <ForgotPassword
                    isOpen={isForgotPasswordOpen}
                    handleBackButton={() => handleBackButton("forgotPassword")}
                    onClose={handleForgotPasswordClose}
                />
            )}
        </>
    );
};

export default AuthLayout;
